import type { OptimizedProductImages } from './optimizeProductImage';

/** Extensión en bucket product-images (webp nativo, jpg en web sin encoder webp). */
export type CatalogImageFileExt = 'webp' | 'jpg';

export function catalogImageFileExt(optimized: OptimizedProductImages): CatalogImageFileExt {
  return optimized.storageFormat === 'jpeg' ? 'jpg' : 'webp';
}

export function catalogImageContentType(ext: CatalogImageFileExt): string {
  return ext === 'jpg' ? 'image/jpeg' : 'image/webp';
}

export function catalogVariantStoragePath(
  orgId: string,
  entityId: string,
  variant: 'thumb' | 'medium' | 'full',
  ext: CatalogImageFileExt,
): string {
  return `${orgId}/${entityId}-${variant}.${ext}`;
}
